module.exports = __webpack_public_path__ + "img/map.cfefb900.png";